(function () {
  function initHeaderCategoryMenu(root) {
    if (!root || root.dataset.headerCategoryInitialized === 'true') return;

    var toggle = root.querySelector('[data-header-category-toggle]');
    var panel = root.querySelector('[data-header-category-panel]');
    var closeControls = root.querySelectorAll('[data-header-category-close]');
    var items = root.querySelectorAll('[data-header-category-item]');
    var closeTimer = null;
    var transitionDelay = 320;
    var resizeFrame = null;
    var navigationResizeObserver = null;
    var headerClassObserver = null;

    if (!toggle || !panel) return;

    root.dataset.headerCategoryInitialized = 'true';

    function getPrimaryNavigationList() {
      var navigation = root.closest('.site-navigation');
      var lists;
      var index;

      if (!navigation) return null;

      lists = navigation.querySelectorAll('.navmenu-depth-1');

      for (index = 0; index < lists.length; index += 1) {
        if (
          lists[index].parentElement === navigation &&
          !lists[index].classList.contains('site-navigation__secondary-menu')
        ) {
          return lists[index];
        }
      }

      return null;
    }

    function updateDesktopNavigationVisibility() {
      var list = getPrimaryNavigationList();
      var listRect;
      var children;
      var hideFromIndex = -1;
      var index;

      if (!list) return;

      children = Array.prototype.slice.call(list.children);

      children.forEach(function (child) {
        child.classList.remove('header-category-menu__nav-overflow-hidden');
      });

      if (window.innerWidth >= 1024) {
        listRect = list.getBoundingClientRect();

        if (listRect.width <= 0 || listRect.height <= 0) {
          list.classList.remove('header-category-menu__nav-ready');
          return;
        }

        for (index = 0; index < children.length; index += 1) {
          var childRect = children[index].getBoundingClientRect();

          if (
            childRect.width > 0 &&
            (childRect.left < listRect.left || childRect.right > listRect.right - 1)
          ) {
            hideFromIndex = index;
            break;
          }
        }

        if (hideFromIndex >= 0) {
          children.slice(hideFromIndex).forEach(function (child) {
            child.classList.add('header-category-menu__nav-overflow-hidden');
          });
        }
      }

      list.classList.add('header-category-menu__nav-ready');
    }

    function scheduleDesktopNavigationVisibility() {
      var list = getPrimaryNavigationList();

      if (list) {
        list.classList.remove('header-category-menu__nav-ready');
      }

      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(updateDesktopNavigationVisibility);
    }

    function observeDesktopNavigationLayout() {
      var list = getPrimaryNavigationList();
      var navigation = list && list.parentElement;
      var header = root.closest('[data-site-header]');

      if (window.ResizeObserver && list && navigation) {
        navigationResizeObserver = new ResizeObserver(scheduleDesktopNavigationVisibility);
        navigationResizeObserver.observe(navigation);
        navigationResizeObserver.observe(list);
      }

      if (window.MutationObserver && header) {
        headerClassObserver = new MutationObserver(scheduleDesktopNavigationVisibility);
        headerClassObserver.observe(header, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }

    function focusElement(element) {
      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }

    function setActiveItem(activeItem) {
      Array.prototype.forEach.call(items, function (item) {
        var isActive = item === activeItem;
        var link = item.querySelector('[data-header-category-link]');

        item.classList.toggle('is-active', isActive);

        if (link && link.hasAttribute('aria-expanded')) {
          link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });
    }

    function setCloseControlsHidden(isHidden) {
      Array.prototype.forEach.call(closeControls, function (control) {
        if (control !== panel) {
          control.hidden = isHidden;
        }
      });
    }

    function setOpen(isOpen) {
      window.clearTimeout(closeTimer);

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        document.documentElement.classList.add('header-category-menu-open');
        panel.hidden = false;
        setCloseControlsHidden(false);

        var activeItem = root.querySelector('[data-header-category-item].is-active') || items[0];
        if (activeItem) setActiveItem(activeItem);

        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
          focusElement(panel);
        });
      } else {
        root.classList.remove('is-open');

        closeTimer = window.setTimeout(function () {
          panel.hidden = true;
          setCloseControlsHidden(true);
          document.documentElement.classList.remove('header-category-menu-open');
        }, transitionDelay);
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    Array.prototype.forEach.call(closeControls, function (control) {
      control.addEventListener('click', function () {
        setOpen(false);
        focusElement(toggle);
      });
    });

    Array.prototype.forEach.call(items, function (item) {
      item.addEventListener('mouseenter', function () {
        setActiveItem(item);
      });

      item.addEventListener('focusin', function () {
        setActiveItem(item);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        focusElement(toggle);
      }
    });

    scheduleDesktopNavigationVisibility();
    observeDesktopNavigationLayout();
    window.addEventListener('resize', scheduleDesktopNavigationVisibility);
    window.addEventListener('load', scheduleDesktopNavigationVisibility);
    window.addEventListener('pageshow', scheduleDesktopNavigationVisibility);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleDesktopNavigationVisibility);
    }
  }

  function initAllHeaderCategoryMenus() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-header-category-menu]'),
      initHeaderCategoryMenu
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeaderCategoryMenus);
  } else {
    initAllHeaderCategoryMenus();
  }

  document.addEventListener('shopify:section:load', initAllHeaderCategoryMenus);
}());
